const classNames = {
  slider: {
    wrap: 'slider__wrap',
    container: 'js-slider',
    prev: 'js-slider-prev',
    next: 'js-slider-next',
    pagination: 'js-slider-pagination',
    slide: 'swiper-slide',
    gallery: 'js-gallery',
  },
  plugin: {
    container: 'swiper-container',
    initialized: 'swiper-container-initialized',
    activeSlide: 'swiper-slide-active',
  },
}

export default classNames
